import { render, staticRenderFns } from "./AtemDownstreamKeyPanel.vue?vue&type=template&id=18b42538&scoped=true&"
import script from "./AtemDownstreamKeyPanel.vue?vue&type=script&lang=js&"
export * from "./AtemDownstreamKeyPanel.vue?vue&type=script&lang=js&"
import style0 from "./AtemDownstreamKeyPanel.vue?vue&type=style&index=0&id=18b42538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b42538",
  null
  
)

export default component.exports